import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import vijayalakshmidoc from '../../../../assets/images/Doctorsimages/vijayalakshmidoc.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const VijayalakshmiDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. Vijaya Lakshmi Dasari | Best Dermatologist & Cosmetologist in Gachibowli Hyderabad | HCura";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Vijaya Lakshmi Dasari (MBBS, D.V., PGDACC), a veteran Dermatologist at HCura Multispeciality Clinic, Gachibowli. With 23+ years of experience and 15+ years in lasers & chemical peels, she offers elite skin and hair care. Book your consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dermatologist in Gachibowli Hyderabad, top cosmetologist in Gachibowli, Dr. Vijaya Lakshmi Dasari Hyderabad, HCura Multispeciality Clinic Gachibowli doctors, laser skin specialist Hyderabad, chemical peels expert Hyderabad, hair transplant doctor Gachibowli, female dermatologist in Hyderabad, Osmania Medical College dermatologist, skin specialist for corporate professionals Hyderabad, clinical research doctor Hyderabad, advanced aesthetic treatments Gachibowli, best doctor for acne and pigmentation Hyderabad, consultant dermatologist near me Gachibowli, International SOS consultant doctor Hyderabad"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-vijayalakshmi/dermatologist-aesthetic-specialist-gachibowli-hyderabad";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');

    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;

        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save('Dr.Vijaya_Lakshmi_Dasari_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Vijaya Lakshmi Dasari</span>
                  <span className="veenadoc-title-credentials">(MBBS, D.V., PGDACC)</span>
                  <span className="veenadoc-title-location">Gachibowli, Hyderabad</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly distinguished medical professional and a cornerstone of dermatological excellence in Hyderabad. 
                    Currently serving as a Consultant at <strong>HCura Multispeciality Clinic, Gachibowli</strong>, she brings a 
                    formidable <strong>23 years</strong> of clinical experience, defining her career with clinical precision and aesthetic mastery.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={vijayalakshmidoc} alt="Dr. Vijaya Lakshmi Dasari - Expert Dermatologist at HCura Gachibowli" className="veenadoc-doctor-image" title='Dr. Vijaya Lakshmi Dasari – Expert Dermatologist at HCura Gachibowli' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Vijaya Lakshmi Dasari</h2>
                  <p>
                   Dr. Vijaya Lakshmi Dasari is an alumna of the prestigious <strong> Osmania Medical College</strong>, where she completed both her graduation and post-graduation. Throughout her career, she has built a reputation for clinical precision, having worked at Hyderabad’s most elite medical institutions, including  <strong>Nizam’s Institute of Medical Sciences (NIMS)</strong> , Mediciti, and Narayana Hrudayalaya. Notably, she dedicated five years to clinical research at Mediciti Hospital (Medicover), serving as an investigator. Patients seeking the top skin specialist in Gachibowli choose Dr. Vijaya Lakshmi for her deep-rooted expertise in super-speciality environments, allowing her to diagnose and treat complex dermatological conditions with the accuracy that only decades of experience can provide.
                  </p>
                  <p>
                    Patients seeking the top skin specialist in Gachibowli choose Dr. Vijaya Lakshmi for her deep-rooted expertise 
                    in super-speciality environments. This high-level exposure allows her to diagnose and treat complex 
                    dermatological conditions with the accuracy that only decades of experience can provide.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Pioneer in Aesthetic Medicine & Lasers</h2>
                  <p>
                    A true pioneer in aesthetic medicine, Dr. Vijaya Lakshmi has specialized in advanced lasers and chemical peels 
                    for over 15 years. Her technical proficiency was further refined during her tenure at the <strong>Srinivasa Skin Clinic</strong> 
                    and <strong>Deepti Hair Transplant Clinic</strong>, where she mastered the art of hair restoration and non-surgical skin rejuvenation.
                  </p>
                  <p>
                    Whether it is addressing stubborn pigmentation, acne scarring, or anti-aging concerns, her results-driven 
                    approach ensures that every patient achieves their desired aesthetic goals safely. Her specialization in 
                    cosmetology procedures like microdermabrasion and cauterization has made her a trusted name in Hyderabad.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">MBBS, D.V., PGDACC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">23+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dermatology & Cosmetology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Gachibowli, Hyderabad</span>
                    </div>
                  </div>
                </div>

                {/* Global Healthcare & Research */}
                <div className="veenadoc-article-block">
                  <h2>Global Healthcare & Clinical Research Expertise</h2>
                  <p>
                    What makes Dr. Vijaya Lakshmi truly unique is her extensive background in global healthcare and clinical research. 
                    For five years, she served as a Consultant Doctor for International SOS, providing expert medical care to 
                    employees of global tech giants like Google and Intel.
                  </p>
                  <p>
                    In the research community, she is a respected figure, having served as a Principal Investigator and 
                    Co-Investigator for landmark clinical trials at organizations such as Zenrise, Aizant Clinical Research, 
                    and NIMS. Her involvement in Phase 2, 3, and 4 trials ensures that her patients benefit from 
                    evidence-based treatments and the latest medical innovations.
                  </p>
                </div>

                {/* Corporate & Academic Contributions */}
                <div className="veenadoc-article-block">
                  <h2>Corporate Healthcare & Academic Contributions</h2>
                  <p>
                    Her corporate healthcare experience is complemented by her role as a Medical Advisor for Pharmacovigilance 
                    at Tech Mahindra, highlighting her unwavering commitment to patient safety and international medical standards. 
                    Beyond her practice, she dedicated a year to academia as a faculty member in the Dermatology department 
                    at TRR Medical College, mentoring the next generation of specialists.
                  </p>
                  <p>
                    This dual expertise in corporate health and clinical research allows her to provide a professional who not only 
                    provides treatments but also focuses on safety, nutrition, and long-term wellness.
                  </p>
                </div>

                {/* Trichology & Hair Restoration */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Trichology & Hair Restoration</h2>
                  <p>
                    Hair care is another area where Dr. Vijaya Lakshmi has become a trusted name. With her experience in 
                    hair transplant clinics, she provides effective treatments for hair thinning, scalp infections, and 
                    premature greying. She offers advanced therapies such as PRP (Platelet-Rich Plasma) and hair restoration 
                    procedures to ensure effective results.
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Vijaya Lakshmi for Complete Skin Wellness</h2>
                  <p>
                    Choosing Dr. Vijaya Lakshmi at HCura Multispeciality Clinic means selecting a doctor who has been at the 
                    forefront of dermatology for over two decades. She provides the assurance of safe treatments, the expertise 
                    of modern aesthetic science, and the wisdom of a master clinician.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier skin, restored hair, and the confidence 
                    that comes from being treated by one of Hyderabad's most seasoned experts.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Merging clinical wisdom with aesthetic perfection"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Vijaya Lakshmi's Philosophy</p>
                  </div>
                  <p>
                    She believes that skin health is a vital component of overall well-being and provides customized 
                    treatment plans that address both medical needs and cosmetic aspirations.
                  </p>
                </div>

                {/* Services */}
                <div className="veenadoc-sidebar-card">
                  <h3>Specialized Services</h3>
                  <ul className="veenadoc-services-list">
                    <li>✨ Advanced Laser Therapy</li>
                    <li>🧪 Expert Chemical Peels</li>
                    <li>💇‍♂️ Hair Restoration</li>
                    <li>🔬 Clinical Research</li>
                    <li>🛡️ Corporate Health</li>
                    <li>🏥 Clinical Dermatology</li>
                  </ul>
                </div>

                {/* Practice Location */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Gachibowli, Hyderabad</h4>
                      <p>HCura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience elite dermatological care with Dr. Vijaya Lakshmi's personalized approach.</p>
                  <button
                    className="veenadoc-sidebar-btn-primary"
                    onClick={() => window.location.href = 'tel:+919849817825'}
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button
                    className="veenadoc-sidebar-btn-secondary"
                    onClick={() => window.location.href = 'tel:+919849817825'}
                  >
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Doctor Profile as PDF
        </button>
      </div>
    </>
  )
}

export default VijayalakshmiDoc;
